import React, { useMemo } from 'react';
import { Formik } from 'formik';

import notification from '../../../config/notification';
import reportsEndpoints from '../../../api/services/reportsEndpoints';
import { openFileByteArray } from '../../../utils/forms/files';

import { REPORT_MAP } from '../config/reports-config';

import { useTheme } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import Loading from '../../../layouts/Loading';
import PageWrapper from '../components/temp/PageWrapper';
import useQueryParam from '../hooks/use-query-param';
import ReportFooter from '../components/ReportFooter';

export default function ReportsContainer() {
  const theme = useTheme();
  const id = useQueryParam('type');

  const report = REPORT_MAP[id];
  const hasReport = Boolean(report);

  const SelectedReportComponent = useMemo(() => {
    return hasReport && report.Component;
    // eslint-disable-next-line
  }, [id]);

  const handleSubmitFilter = async (values, formik) => {
    try {
      let response = await reportsEndpoints.generateReportFile(id, values);
      if (response && response.status === 204) {
       notification('Nenhum resultado encontrado para o(s) filtro(s) informado(s).', {
          toastId: 'REPORTS_NO_RESULT_FOUND',
          type: 'warn',
        });
      } else if (response && response.status === 200) {
        openFileByteArray({ data: response.data, fileName: report.fileName });
        notification('Relatório gerado com sucesso.', {
          toastId: 'REPORTS_SUCCESS',
          type: 'success',
        });
      }
    } catch (error) {
      notification('Ocorreu um erro ao gerar o relatório.', {
        toastId: 'REPORTS_ERROR',
        type: 'error',
      });
    } finally {
      formik.setSubmitting(false);
    }
  };

  const checkValidation = ({ isValidating, isValid, submit }) => () => {
    if (isValidating === false && isValid === false) {
      notification('Por favor, corrija os campos inválidos.', {
        type: 'error',
      });

    } else {
      submit();
    }
  }

  const renderReport = () => {
    return (
      !!id && (
        <Formik initialValues={REPORT_MAP[id].formInitials} onSubmit={handleSubmitFilter} enableReinitialize validateOnChange={false}>
          {({ handleSubmit, isSubmitting, isValidating, isValid, validateField }) => (
            <>
              <Grid item xs={12} container>
                <Grid item xs={12}>
                  {isSubmitting && <Loading />}
                  <SelectedReportComponent validateField={validateField}/>
                </Grid>
              </Grid>
              <ReportFooter
                onSave={checkValidation({isValidating: isValidating, isValid: isValid, submit: handleSubmit})}
                buttonLabel="GERAR RELATÓRIO"
                disabled={isSubmitting}
              />
            </>
          )}
        </Formik>
      )
    );
  };

  return (
    <>
      <PageWrapper
        title={hasReport ? report.title : 'Relatórios'}
        marginBottom={theme.spacing(3)}
        isPlain
      >
        {hasReport ? (
          renderReport()
        ) : (
          <Typography variant="h6">Nenhum relatório encontrado.</Typography>
        )}
      </PageWrapper>
    </>
  );
}
